import { createSharedComposable } from '@vueuse/core';
import { computed } from 'vue';
import { useDetailRoute } from '../use-detail-route';
import { transferViewTypeForApi } from '@/domains/detail/dataset/view-type-transfer';
export const useCurrentViewType = createSharedComposable(() => {
    const { viewType, dataType } = useDetailRoute();
    const viewTypeForApi = computed(() => {
        return transferViewTypeForApi(dataType.value, viewType.value);
    });
    return {
        viewTypeForApi,
    };
});
